import {Component, ContentChild, Input} from "@angular/core";
import {FUIButtonComponent} from "../button.component";
import {FUIMarkToggleComponent} from "../../../toggle/mark-toggle/mark-toggle.component";
import {FUIIconComponent} from "../../../icons/icon/icon.component";

@Component({
    selector: "fui-header-button",
    styleUrls: ["./header-button.component.scss"],
    templateUrl: "./header-button.component.html",
    standalone: false
})
export class FUIHeaderButtonComponent extends FUIButtonComponent {
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @ContentChild(FUIMarkToggleComponent) public toggle: FUIMarkToggleComponent;
    @Input() public toggled: boolean;
}
